import { render, staticRenderFns } from "./CMaterial.vue?vue&type=template&id=c6cf6cac"
import script from "./CMaterial.vue?vue&type=script&lang=js"
export * from "./CMaterial.vue?vue&type=script&lang=js"
import style0 from "./CMaterial.vue?vue&type=style&index=0&id=c6cf6cac&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6cf6cac')) {
      api.createRecord('c6cf6cac', component.options)
    } else {
      api.reload('c6cf6cac', component.options)
    }
    module.hot.accept("./CMaterial.vue?vue&type=template&id=c6cf6cac", function () {
      api.rerender('c6cf6cac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CMaterial.vue"
export default component.exports